// extracted by mini-css-extract-plugin
export default {"externalSystemDescription":"style--externalSystemDescription--5656c7","header":"style--header--1a1b45","description":"style--description--912240"};